import BaseProxy from '../../proxies/Proxy'

class ServicesProxy extends BaseProxy {
  static company_id;

  /**
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    parameters.client = "front";
    super(`companies/${ServicesProxy.company_id}/services`, parameters);
  }
}

export default ServicesProxy;
